import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlSignature } from '../../../../common/apiEndpoint';

@Injectable({
  providedIn: 'root'
})
export class UseraccountserviceService {

  private readonly TOKEN_KEY = 'sysadmin_token';

  constructor(
    private http: HttpClient,
    private urlSignature: UrlSignature
  ) { }

  // Create admin user account with authentication
  createAdminUser(userData: any): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post(this.urlSignature.sysaccountcreationurl, userData, { headers });
  }

  // Get HTTP headers with token from localStorage
  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem(this.TOKEN_KEY);
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }

  // Check if user is authenticated
  isAuthenticated(): boolean {
    return !!localStorage.getItem(this.TOKEN_KEY);
  }
}